/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Rule } from './Rule.js';
import {
    RuleFromJSON,
    RuleFromJSONTyped,
    RuleToJSON,
} from './Rule.js';
import type { SectionSummary } from './SectionSummary.js';
import {
    SectionSummaryFromJSON,
    SectionSummaryFromJSONTyped,
    SectionSummaryToJSON,
} from './SectionSummary.js';

/**
 * 
 * @export
 * @interface ScorecardTemplate
 */
export interface ScorecardTemplate {
    /**
     * 
     * @type {number}
     * @memberof ScorecardTemplate
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ScorecardTemplate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ScorecardTemplate
     */
    parameters?: string;
    /**
     * 
     * @type {Date}
     * @memberof ScorecardTemplate
     */
    dateCreated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ScorecardTemplate
     */
    dateUpdated?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ScorecardTemplate
     */
    isDraft?: boolean;
    /**
     * 
     * @type {Array<Rule>}
     * @memberof ScorecardTemplate
     */
    rules?: Array<Rule>;
    /**
     * 
     * @type {Array<SectionSummary>}
     * @memberof ScorecardTemplate
     */
    sections?: Array<SectionSummary>;
}

/**
 * Check if a given object implements the ScorecardTemplate interface.
 */
export function instanceOfScorecardTemplate(value: object): boolean {
    return true;
}

export function ScorecardTemplateFromJSON(json: any): ScorecardTemplate {
    return ScorecardTemplateFromJSONTyped(json, false);
}

export function ScorecardTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScorecardTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'parameters': json['parameters'] == null ? undefined : json['parameters'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateUpdated': json['dateUpdated'] == null ? undefined : (new Date(json['dateUpdated'])),
        'isDraft': json['isDraft'] == null ? undefined : json['isDraft'],
        'rules': json['rules'] == null ? undefined : ((json['rules'] as Array<any>).map(RuleFromJSON)),
        'sections': json['sections'] == null ? undefined : ((json['sections'] as Array<any>).map(SectionSummaryFromJSON)),
    };
}

export function ScorecardTemplateToJSON(value?: ScorecardTemplate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'parameters': value['parameters'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateUpdated': value['dateUpdated'] == null ? undefined : ((value['dateUpdated']).toISOString()),
        'isDraft': value['isDraft'],
        'rules': value['rules'] == null ? undefined : ((value['rules'] as Array<any>).map(RuleToJSON)),
        'sections': value['sections'] == null ? undefined : ((value['sections'] as Array<any>).map(SectionSummaryToJSON)),
    };
}

